import React from 'react';
import NumberFormat from 'react-number-format';

export default function PriceFormat({className, value, prefix = '', suffix = ''}) {
    return (
        <NumberFormat
            value={value}
            displayType={'text'}
            decimalSeparator={','}
            thousandSeparator={'.'}
            prefix={prefix !== '' ? prefix : '€ '}
            fixedDecimalScale={true}
            decimalScale={2}
            renderText={(formatValue) => {
                return (
                    <span className={className}>
                        {formatValue.replace(',00', '')}{suffix}
                    </span>
                )
            }}
        />
    );
}
